import coreActions from 'marketplace-front-core/store/index'

export const actions = coreActions
